module.exports = "/fonts/HelveticaNeue Medium.ttf?0a13c540938b1b7dd3996b02ea568e5f";